import type { MouseEvent } from 'react';
import React from 'react';

import { useCloseDrawer, useGetOpenDrawer } from '../../../hooks/drawer';
import VariationDrawer from '../../MvcDrawer/VariationDrawer';
import { getClickTrackingHandler } from '../tracking/tracking';
import type { ProductListVariation, TrackingContext } from '../types/types';
import { getVariationTitle } from '../utils/utils';

interface UseVariationDrawerParams {
  sku: string;
  url: string;
  variations: ProductListVariation[];
  trackingContext: TrackingContext;
}

interface UseVariationDrawerReturn {
  handleClick: () => void;
  clickTrackingHandler: (event: MouseEvent) => void;
}

export const useVariationDrawer = ({
  sku,
  url,
  variations,
  trackingContext,
}: UseVariationDrawerParams): UseVariationDrawerReturn => {
  const openDrawer = useGetOpenDrawer();
  const closeDrawer = useCloseDrawer();
  const clickTrackingHandler = getClickTrackingHandler(sku, trackingContext);

  const handleClick = () => {
    const title = getVariationTitle(variations);
    openDrawer({
      title,
      content: <VariationDrawer sku={sku} url={url} title={title} closeDrawer={closeDrawer} />,
    });
  };

  return { handleClick, clickTrackingHandler };
};
